// filterModel = {
//     name:String,
//     filters:Object
// }
import Vue from 'vue'

export default{
    namespaced: true,
    state:{
        filters:{}
    },
    mutations:{
        addOrUpdateFilter(state,filter){
            Vue.set(state.filters,filter.name,filter.filterData)
        }
    },
    getters:{},
    setters:{}
}